/*eslint-disable*/
import React, { useEffect, useMemo } from "react";
import "./styles.scss";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LaunchIcon from "@mui/icons-material/Launch";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Moment from "moment/moment";
import { connect } from "react-redux";
import { emptyPassedParams } from "../../actions/screen";
import {
  clearAllStationFaults,
  clearStation,
  clearStationData,
  createStation,
  getLimitZonesById,
  getSpeedLimitZones,
  getStationById,
  getStations,
  getStationsStatuses,
  getVehicleStatuses,
  refreshStation,
  reloginStation,
  saveLimitZones,
  updateLimitZones,
  updateStation,
} from "../../actions/stations";
import DropDownMenu from "../../components/menu";
import StationModal from "../../components/modal/stationModal";
import StationQrModal from "../../components/modal/stationQrModal";
import StatusIndicator from "../../components/statusIndicator";
import Tag from "../../components/Tags";
import useCustomTable from "../../components/table/CustomTable";
import { GET_METHOD, POST_METHOD } from "../../constants/apiMethods";
import {
  CHARGE_STATION,
  stationTypes,
  stationVehicleStatuses,
  TAG_COLOR,
} from "../../constants/const";
import { getErrorDescription } from "../../constants/errorCodeConfig";
import { useCity, useShowToast } from "../../hooks";
import { strings } from "../../I18n";
import lanterneLogo from "../../images/lanterne-logo.png";
import { callApi } from "../../middleware/api";
import {
  cityNameById,
  reformatFilter,
  reformatSort,
  stringFromValue,
} from "../../utils/utils";

export const TAB_STATE = {
  STATIONS: "stations",
  LIMITING_ZONES: "limiting_zones",
};

function StationContainer(props) {
  const {
    clearStation,
    getStations,
    vehicleStatuses,
    clearStationData,
    stationsStatuses,
    getStationsStatuses,
    getStationsSuccess,
    savedCity,
    passedParams,
    getStationById,
    emptyPassedParams,
  } = props;

  const showToast = useShowToast();
  const [stationModalVisible, setStationModalVisible] = React.useState(false);
  const [selectedTab, setSelectedTab] = React.useState(TAB_STATE.STATIONS);
  const [filterObject, setFilterObject] = React.useState([]);
  const { selectedCity } = useCity();
  const [isEdit, setIsEdit] = React.useState(false);
  const [faultModalStation, setFaultModalStation] = React.useState(null);
  const [faultModalDocks, setFaultModalDocks] = React.useState([]);
  const [loadingDocks, setLoadingDocks] = React.useState(false);
  const [qrModalVisible, setQrModalVisible] = React.useState(false);
  const [qrModalStation, setQrModalStation] = React.useState(null);

  useEffect(() => {
    props.getVehicleStatuses();
    props.getStationsStatuses();
  }, []);

  const toggleTabState = (tab) => {
    setSelectedTab(tab);
  };

  const showModal = () => setStationModalVisible(true);

  const hideModal = () => setStationModalVisible(false);

  useEffect(() => {
    if (passedParams) {
      getStationById(passedParams);
      setIsEdit(true);
      emptyPassedParams();
    }
  }, [passedParams, getStationById, emptyPassedParams]);

  useEffect(() => {
    if (props.createStationSuccess) {
      showToast("Success", "success");
      clearStation();
      hideModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.createStationSuccess,
    clearStation,
    getStations,
    savedCity,
    props.createSpeedLimitZoneSuccess,
  ]);

  useEffect(() => {
    if (
      props.updateStationSuccess ||
      props.updateSpeedLimitZoneSuccess ||
      props.createSpeedLimitZoneSuccess
    ) {
      showToast("Success", "success");
      clearStation();
      clearStationData();
      reloadData();
      // getStations(0, '', '', savedCity || '', pageSize)
      hideModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.updateStationSuccess,
    clearStation,
    savedCity,
    props.updateSpeedLimitZoneSuccess,
    props.createSpeedLimitZoneSuccess,
  ]);

  useEffect(() => {
    if (props.clearAllStationFaultsSuccess) {
      showToast("Faults cleared", "success");
      clearStationData();
      reloadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.clearAllStationFaultsSuccess]);

  useEffect(() => {
    if (props.stationByIdSuccess) {
      clearStationData();
      showModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.stationByIdSuccess, savedCity, props.speedLimitZoneSuccess]);

  useEffect(() => {
    if (props.speedLimitZoneSuccess) {
      clearStationData();
      showModal();
    }
  }, [props.speedLimitZoneSuccess, savedCity]);

  const closeModal = () => {
    props.clearStation();
    hideModal();
  };

  const showCreationModal = () => {
    getStationsStatuses();
    showModal();
  };

  const openQrModal = (station) => {
    setQrModalStation(station);
    setQrModalVisible(true);
  };

  const closeQrModal = () => {
    setQrModalVisible(false);
    setQrModalStation(null);
  };

  const edit = (station) => (
    <div className={"edit"}>
      <div
        className={"stationLink"}
        style={{ padding: 5 }}
        onClick={() => showStationInfo(station)}
      >
        {strings("descriptions.edit")}
      </div>
    </div>
  );
  const momentDate = (date) =>
    date ? Moment(date + "Z").format("DD.MM.YYYY HH:mm") : "-";

  const openFaultModal = async (station) => {
    setFaultModalStation(station);
    setLoadingDocks(true);
    setFaultModalDocks([]);
    try {
      const data = await callApi(
        `/station-service/dashboard/docks?stationId=${station.id}&size=50`,
        GET_METHOD
      );
      const faultyDocks = (data?.content || []).filter(
        (d) => d.status === "MALFUNCTION" && d.lastErrorCode
      );
      setFaultModalDocks(faultyDocks);
    } catch (error) {
      console.error("Failed to fetch docks:", error);
      showToast("Failed to load dock details", "error");
    } finally {
      setLoadingDocks(false);
    }
  };

  const closeFaultModal = () => {
    setFaultModalStation(null);
    setFaultModalDocks([]);
  };

  const handleClearDockFault = async (dockId) => {
    try {
      await callApi(
        `/station-service/dashboard/docks/${dockId}/clear-fault`,
        POST_METHOD
      );
      showToast("Fault clear command sent", "success");
      setFaultModalDocks((prev) => prev.filter((d) => d.id !== dockId));
      setTimeout(() => reloadData(), 1500);
    } catch (error) {
      showToast("Failed to clear fault", "error");
    }
  };

  const faultsDisplay = (station) => {
    if (station.brand !== "KINGMETER") return "-";
    if (station.status === "OFFLINE") return "-";
    const count = station.faultyDockCount || 0;
    if (count === 0) {
      return <span style={{ color: "#4caf50" }}>✓</span>;
    }
    return (
      <Chip
        icon={<ErrorOutlineIcon />}
        label={`${count} fault${count > 1 ? "s" : ""}`}
        color="error"
        variant="outlined"
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          openFaultModal(station);
        }}
        title="Click to see fault details"
        sx={{
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "rgba(244, 67, 54, 0.08)",
          },
        }}
      />
    );
  };

  const getMenuItems = (station) => {
    const items = [
      {
        action: () => openQrModal(station),
        title: "View QR Code",
      },
    ];

    if (station.type === CHARGE_STATION) {
      items.push({
        action: () => props.refreshStation(station.id),
        title: strings("buttons.refresh"),
      });
      items.push({
        action: () => props.reloginStation(station.id),
        title: strings("buttons.relogin"),
      });

      if (station.brand === "KINGMETER") {
        const hasFaults = station.faultyDockCount > 0;
        items.push({
          action: () => props.clearAllStationFaults(station.id),
          title: "Clear All Faults",
          disabled: !hasFaults,
        });
      }
    }

    return items;
  };

  const actions = (station) => (
    <DropDownMenu
      item={station}
      menuItems={getMenuItems(station)}
      current={strings("descriptions.actions")}
    />
  );

  const showStationInfo = (station) => {
    if (selectedTab === TAB_STATE.STATIONS) {
      props.getStationById(station.id);
      setIsEdit(true);
    } else {
      props.getLimitZonesById(station.id);
      setIsEdit(true);
    }

    getStationsStatuses();
  };

  const columns = useMemo(
    () => [
      {
        id: "sortable7",
        name: "",
        selector: "id",
        center: true,
        sortable: true,
        cell: (row) => edit(row),
      },
      {
        id: "sortable8",
        name: strings("descriptions.stationCode"),
        selector: "code",
        center: true,
        sortable: true,
      },
      {
        id: "sortable9",
        name: strings("descriptions.stationName"),
        selector: "code",
        center: true,
        sortable: true,
        cell: (row) => stringFromValue(row?.name),
      },
      {
        id: "sortable10",
        name: strings("descriptions.lastSeenOnline"),
        selector: "code",
        center: true,
        sortable: true,
        cell: (row) => momentDate(row?.lastSeenOnline),
      },
      {
        id: "sortable1",
        name: strings("descriptions.placesNumber"),
        selector: "dockCount",
        center: true,
        sortable: true,
      },
      {
        id: "sortable12",
        name: strings("descriptions.bikeNumber"),
        selector: "vehicleCount",
        center: true,
        sortable: true,
      },
      {
        id: "sortable_faults",
        name: "Faults",
        selector: "faultyDockCount",
        center: true,
        sortable: false,
        cell: (row) => faultsDisplay(row),
      },
      {
        id: "sortable13",
        name: strings("descriptions.status"),
        selector: "status",
        center: true,
        sortable: true,
        cell: (row) => (
          <StatusIndicator status={row?.status?.replace(/_/g, " ")} />
        ),
      },
      {
        id: "sortable14",
        name: strings("descriptions.type"),
        selector: "type",
        center: true,
        sortable: true,
        cell: (row) => row?.type?.replace(/_/g, " "),
      },
      {
        id: "sortable15",
        name: strings("descriptions.cityProject"),
        selector: "vehicleCount",
        center: true,
        sortable: false,
        cell: (row) =>
          stringFromValue(cityNameById(props?.citiesList, row?.cityId)),
      },
      {
        id: "sortable16",
        name: "",
        selector: "vehicleCount",
        center: true,
        sortable: false,
        width: "200px",
        cell: (row) => actions(row),
      },
    ],
    [selectedTab]
  );

  const reloadData = () => {
    if (selectedTab === TAB_STATE.STATIONS) {
      getStations(
        localPage,
        debouncedSearchTerm,
        selectedCity || "",
        reformatSort(sortData),
        reformatFilter(filterData),
        localRows
      );
    } else {
      props.getSpeedLimitZones(
        localPage,
        debouncedSearchTerm,
        selectedCity || "",
        reformatSort(sortData),
        reformatFilter(filterData),
        localRows
      );
    }
  };

  const addButtonClick = () => {
    setIsEdit(false);
    showCreationModal();
  };

  useEffect(() => {
    if (vehicleStatuses && stationsStatuses) {
      setFilterObject([
        {
          filterBy: "stationVehiclesStatus",
          filterValue: vehicleStatuses,
        },
        {
          filterBy: "stationTypes",
          filterValue: stationTypes,
        },
        {
          filterBy: "stationStatuses",
          filterValue: stationsStatuses,
        },

        {
          filterBy: "vehicleStatuses",
          filterValue: stationVehicleStatuses,
        },
      ]);
    }
  }, [vehicleStatuses, stationsStatuses, stationTypes]);

  const speedLimitZoneColumns = useMemo(
    () => [
      {
        id: "sortable7",
        name: "",
        selector: "id",
        center: true,
        sortable: true,
        cell: (row) => edit(row),
      },
      {
        id: "sortable1",
        name: "ID",
        selector: "id",
        center: true,
        sortable: false,
      },
      {
        id: "sortable1",
        name: "Name",
        selector: "name",
        center: true,
        sortable: false,
      },
      {
        id: "sortable2",
        name: "Code",
        selector: "code",
        center: true,
        sortable: false,
      },
      {
        id: "sortable3",
        name: "CityId",
        selector: "cityId",
        center: true,
        sortable: false,
      },
      {
        id: "sortable4",
        name: "Max Speed",
        selector: "maxSpeed",
        center: true,
        sortable: false,
        cell: (row) => `${row?.maxSpeed} km/h`,
      },
      {
        id: "sortable5",
        name: "Description",
        selector: "description",
        center: true,
        sortable: false,
      },
      {
        id: "sortable6",
        name: "Status",
        selector: "status",
        center: true,
        sortable: false,
        cell: (row) => (
          <Tag
            colorTag={
              row?.status === "ONLINE" ? TAG_COLOR.GREEN : TAG_COLOR.RED
            }
            text={row.status}
          />
        ),
      },
    ],
    [selectedTab]
  );

  const {
    renderCustomTable,
    renderHeaderBar,
    localPage,
    localRows,
    sortData,
    debouncedSearchTerm,
    filterData,
    setLoading,
    resetPagination,
  } = useCustomTable(
    selectedTab === TAB_STATE.STATIONS ? columns : speedLimitZoneColumns,
    selectedTab === TAB_STATE.STATIONS
      ? props.stationsResult
      : props.speedLimitZoneList,
    reloadData,
    addButtonClick,
    filterObject,
    selectedTab === TAB_STATE.STATIONS ? "Stations" : "Speed limiting zones",
    selectedTab === TAB_STATE.STATIONS,
    true
  );

  useEffect(() => {
    resetPagination();
  }, [selectedTab]);

  useEffect(() => {
    reloadData();
  }, [
    localPage,
    debouncedSearchTerm,
    selectedCity,
    sortData,
    filterData,
    localRows,
    selectedTab,
    props.updateStationSuccess,
    props.createStationSuccess,
  ]);

  useEffect(() => {
    setLoading(
      getStationsSuccess === undefined ||
        !props.speedLimitZoneListSuccess === undefined
    );
  }, [getStationsSuccess]);

  const content = () => (
    <>
      {renderHeaderBar()}
      {props.adminDetails?.whiteLabelId === 999 && (
        <div style={{ padding: "0 20px", marginBottom: "16px" }}>
          <Button
            component="a"
            href="https://dashboard.lanterne.ai/fleets/parking-locations?fleet=lisa-demo"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            startIcon={
              <img src={lanterneLogo} alt="Lanterne" height="20" width="20" />
            }
            endIcon={<LaunchIcon />}
            sx={{
              backgroundColor: "#083f6d",
              color: "white",
              textTransform: "none",
              borderRadius: "6px",
              padding: "8px 16px",
              fontSize: "13px",
              fontWeight: 500,
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              "&:hover": {
                backgroundColor: "#0c4d8c",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
              },
            }}
            title="Opens Lanterne operations platform"
          >
            Lanterne
          </Button>
        </div>
      )}
      {renderCustomTable()}
      <StationModal
        visible={stationModalVisible}
        clearStation={closeModal}
        station={props.station}
        speedLimitZone={props.speedLimitZone}
        updateStation={isEdit ? props.updateStation : props.createStation}
        updateSpeedLimitZone={
          isEdit ? props.updateLimitZones : props.saveLimitZones
        }
        cityNameList={props.citiesList}
        statuses={stationsStatuses}
        selectedTab={selectedTab}
        isEdit={isEdit}
        defaultCityId={savedCity}
      />
      <StationQrModal
        visible={qrModalVisible}
        station={qrModalStation}
        whitelabel={props.adminDetails?.whitelabelCode || "sharebike"}
        closeAction={closeQrModal}
      />
      <Dialog
        open={!!faultModalStation}
        onClose={closeFaultModal}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ErrorOutlineIcon color="error" />
          Dock Faults - {faultModalStation?.name || "Station"}
        </DialogTitle>
        <DialogContent>
          {loadingDocks ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 3,
                gap: 2,
              }}
            >
              <CircularProgress size={24} />
              <span>Loading dock details...</span>
            </Box>
          ) : faultModalDocks.length === 0 ? (
            <Box sx={{ p: 2, textAlign: "center", color: "#666" }}>
              No faulty docks found
            </Box>
          ) : (
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 1.5, pt: 1 }}
            >
              {faultModalDocks.map((dock) => (
                <Box
                  key={dock.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    backgroundColor: "#fafafa",
                    borderRadius: 1,
                    border: "1px solid #eee",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <span style={{ fontWeight: 500 }}>Dock {dock.code}</span>
                    <Chip
                      size="small"
                      label={`E${dock.lastErrorCode}: ${getErrorDescription(dock.lastErrorCode)}`}
                      color="error"
                      variant="filled"
                    />
                  </Box>
                  <Button
                    size="small"
                    variant="contained"
                    color="warning"
                    onClick={() => handleClearDockFault(dock.id)}
                  >
                    Clear
                  </Button>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeFaultModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );

  return <div className={"dashboardContent"}>{content()}</div>;
}

const mapStateToProps = ({
  stations: {
    stations,
    station,
    stationsResult,
    stationByIdSuccess,
    updateStationSuccess,
    createStationSuccess,
    vehicleStatuses,
    getVehicleStatusesSuccess,
    stationsStatuses,
    getStationsSuccess,
    speedLimitZoneList,
    speedLimitZoneListSuccess,
    speedLimitZone,
    updateSpeedLimitZoneSuccess,
    createSpeedLimitZoneSuccess,
    speedLimitZoneSuccess,
    clearAllStationFaultsSuccess,
  },
  cities: { citiesList, savedCity },
  screen: { pageSize, passedParams },
  auth: { adminDetails },
}) => ({
  stations,
  station,
  stationByIdSuccess,
  updateStationSuccess,
  createStationSuccess,
  stationsResult,
  citiesList,
  savedCity,
  pageSize,
  vehicleStatuses,
  getVehicleStatusesSuccess,
  stationsStatuses,
  getStationsSuccess,
  passedParams,
  speedLimitZoneList,
  speedLimitZoneListSuccess,
  speedLimitZone,
  updateSpeedLimitZoneSuccess,
  createSpeedLimitZoneSuccess,
  speedLimitZoneSuccess,
  clearAllStationFaultsSuccess,
  adminDetails,
});

const mapDispatchToProps = {
  getStations,
  clearStation,
  updateStation,
  createStation,
  getVehicleStatuses,
  clearStationData,
  getStationsStatuses,
  getStationById,
  emptyPassedParams,
  getSpeedLimitZones,
  refreshStation,
  reloginStation,
  clearAllStationFaults,
  updateLimitZones,
  saveLimitZones,
  getLimitZonesById,
};

export default connect(mapStateToProps, mapDispatchToProps)(StationContainer);
